import service from "@/store/services/incidencias-service";

const state = {
  list: {},
  incidencia: {},
  meta: {},
  loading: false,
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, incidencia) => {
    state.incidencia = incidencia;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_LOADING: (state, loading) => {
    state.loading = loading;
  },
};

const actions = {
  list({ commit, dispatch }, params) {
    return service.list(params).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    commit("SET_LOADING", true);
    return service.get(params)
      .then((incidencia) => {
      commit("SET_RESOURCE", incidencia);
        return incidencia;
      })
      .finally(() => {
        commit("SET_LOADING", false);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params).then((incidencia) => {
      commit("SET_RESOURCE", incidencia);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then((incidencia) => {
      commit("SET_RESOURCE", incidencia);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.pagination.total,
  incidencia: (state) => state.incidencia,
  loading: (state) => state.loading,
  dropdown: (state) => {
    /*  state.list.map((incidencia) => console.log(incidencia)); */
    return state.list.map((incidencia) => ({
      id: incidencia.id,
      nombre: incidencia.nombre,
    }));
  },
};

const incidencias = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default incidencias;
